<template>
    <button v-bind:class="{'btn-disabled': disabled, 'btn-big': big, 'layout-gom': layoutGom}" @click="handleClick()">
        <img v-if="!text" :src="icon" v-bind:class="{'btn-big-img': big, 'black': black}">
        <span v-else v-text="text"></span>
    </button>
</template>

<script>
export default {
    name: 'CircleButton',
    props: [
        'icon',
        'disabled',
        'big',
        'black',
        'layoutGom',
        'text'
    ],
    methods: {
        handleClick: function () {
            this.$emit('circleBtnClick')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 3rem;
        border: none;
        outline: none;
        color: @white;
        border-radius: 45px;
        background: @gradient-color;
    }

    .btn-disabled {
        color: @black;
        background: @disabled-color;
        pointer-events: none
    }

    .btn-big {
        width: 4.3rem;
        height: 4.3rem;
    }

    .btn-big-img {
        width: 3.5rem;
    }

    .black {
        filter: brightness(0);
    }

    img {
        width: 2rem;
    }
    .layout-gom {
        width: 8rem;
        span {
            font-size: 1.4rem;
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        button {
            width: 30px;
            height: 30px;
        }
        img {
            width: 20px;
        }
        .btn-big {
            width: 35px;
            height: 35px;
        }
        .btn-big-img {
            width: 25px;
        }
        .layout-gom {
            span {
                font-size: 1.1em !important;
            }
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        button {
            width: 2.5rem;
            height: 2.5rem;
        };

        .btn-big {
            width: 3.5rem;
            height: 3.5rem;
        }

        .btn-big-img {
            width: 2.5rem;
        }
        img {
            width: 1.5rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/CircleButton.vue